import React from 'react'
import { useState } from 'react'

import { useAxios } from '../../utilities/Requests/useAxios'

export interface TrackingContextInterface {
  onboardingKitTrackingInfo: {
    type: string
    trackingNumber: number
    currentTrackingStatus: string
    currentTrackingLocation: string
    currentTrackingDate: string
    delivered: boolean
    patientId: number
  }
  getPatientOnboardingKitTrackingInfo: (patientId: number) => Promise<void>
}

export const TrackingContext =
  React.createContext<TrackingContextInterface | null>(null)

export const TrackingProvider = ({ children }: any) => {
  const { fetch } = useAxios()

  const [onboardingKitTrackingInfo, setOnboardingKitTrackingInfo] = useState({
    type: '',
    trackingNumber: 0,
    currentTrackingStatus: '',
    currentTrackingLocation: '',
    currentTrackingDate: '',
    delivered: false,
    patientId: 0,
  })

  const getPatientOnboardingKitTrackingInfo = async (patientId: number) => {
    const { data, error } = await fetch({
      path: `TrackingRecord/GetPatientOnboardingKitTrackingInfo?PatientId=${patientId}`,
    })

    if (data) {
      setOnboardingKitTrackingInfo(data)
      return data
    } else if (error) {
      throw new Error(`Error in getPatientOnboardingKitTrackingNumber.`)
    }
  }

  return (
    <TrackingContext.Provider
      value={{
        onboardingKitTrackingInfo,
        getPatientOnboardingKitTrackingInfo,
      }}
    >
      {children}
    </TrackingContext.Provider>
  )
}
